module.exports = __webpack_public_path__ + "static/media/yandex.3a42516d.png";